export default __webpack_public_path__ + "static/media/pods.926c3a0f.svg";